__webpack_require__.p = "https://bmidxbaustriaplpreprod.netlify.app/";